/**
 * Section composite component exports
 *
 * Exports the Section component, its props interface, variant function,
 * and variant props type for use throughout the application.
 */
export { Section, type SectionProps } from './Section';
export { sectionVariants, type SectionVariantProps } from './section.variants';
